import React from 'react';
import { Overlay, ModalContainer, Header, Body, Footer } from './styled';

const Modal = ({ title, children, footer, onClose }) => {
  return (
    <Overlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        {title && <Header>{title}</Header>}
        <Body>{children}</Body>
        {footer && <Footer>{footer}</Footer>}
      </ModalContainer>
    </Overlay>
  );
};

export default Modal;
